module.exports = __webpack_public_path__ + "static/media/grip-strength.f317793e.svg";